module.exports = __webpack_public_path__ + "img/vertical_3_2_8017.4ab1953e.png";